export const alertBar = (theme) => ({
    /* Styles applied to the root element. */
    root: {
        width: "100%",
        background: theme.customPalette.secondaryPinkP02,
        color: "white",
    },
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight: 48,
    },
    iconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: 65,
        minHeight: 65,
        maxWidth: 104,
        marginTop: -1,
        marginLeft: -1,
    },
    icon: {
        width: 24,
        height: 24,
    },
    contentWrapper: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginLeft: theme.spacing(3),
    },
    title: {},
    linkClose: {
        "& p": {
            color: "#fff",
        },
    },
    message: {
        color: "#fff",
    },
    actionsWrapper: {
        display: "flex",
        marginLeft: "auto",
        marginRight: theme.spacing(3),
    },
    /* Styles applied to the root element if `severity="error"`*/
    severityError: {
        "& $container": {
            border: `2px solid ${theme.customPalette.secondaryPinkP02}`,
        },
        "& $iconWrapper": {
            backgroundColor: theme.customPalette.secondaryPinkP02,
        },
    },
});
